// Which build this is: filled in by tools/build.mjs at build time.
export interface BuildInfo { version: string; commit: string; time: string }
declare const __BUILD__: BuildInfo | undefined;
export const BUILD: BuildInfo = typeof __BUILD__ !== "undefined" ? __BUILD__ : { version: "dev", commit: "unbuilt", time: "" };
export const buildLabel = (b: BuildInfo) => `v${b.version} · ${b.commit}${b.time ? " · built " + b.time.slice(0, 16).replace("T", " ") + " UTC" : ""}`;
